
import clsx from "clsx";
import { Eye, EyeOff } from "lucide-react";
import { forwardRef, useState } from "react";

interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  required?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      error,
      leftIcon,
      rightIcon,
      required,
      className = "",
      type = "text",
      ...props
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const inputType =
      type === "password"
        ? showPassword
          ? "text"
          : "password"
        : type;

    return (
      <div className="w-full mb-5">
        {label && (
          <label className="mb-1 block text-sm text-white ">
            {label}
            {required && (
              <span className="ml-1 text-red-400">*</span>
            )}
          </label>
        )}

        <div
          className={`
            flex items-center
            rounded-xl
             bg-white/10 backdrop-blur-sm border rounded-lg text-white placeholder-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all
            duration-200
            ${error ? "border-red-400" : "border-white/20"}
          `}
        >
          {leftIcon && (
            <div className="pl-4 text-slate-400">
              {leftIcon}
            </div>
          )}

          <input
            ref={ref}
            type={inputType}
            className={clsx("h-12 w-full bg-transparent px-3 text-base outline-none placeholder:text-slate-400 disabled:cursor-not-allowed disabled:opacity-60", className)}
            {...props}
          />

          {type === "password" ? (
            <button
              type="button"
              onClick={() =>
                setShowPassword(!showPassword)
              }
              className="px-4 text-slate-500"
            >
              {showPassword ? (
                <EyeOff size={20} />
              ) : (
                <Eye size={20} />
              )}
            </button>
          ) : (
            rightIcon && (
              <div className="pr-4 text-slate-400">
                {rightIcon}
              </div>
            )
          )}
        </div>

        {error && (
          <p className="mt-1 text-sm font-medium text-red-300">
            {error}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;